
$(document).on('click','.about-disclosure__past-btns--ttl',function(){
	var $wrap = $(this).parents('.about-disclosure__past-btns');
	var $list = $wrap.find('.about-disclosure__past-btns--list');
	//$list.is(':hidden') ? $wrap.addClass('_active') : $wrap.removeClass('_active');
	$wrap.toggleClass('_active');
	$list.slideToggle('500');
});